module.exports = __webpack_public_path__ + "static/media/lazyaz_app1.c24c0393.jpg";